import {useEffect, useState} from 'react';

import {isNil} from 'ramda';
import {isNumber} from 'ramda-adjunct';

import {usePrevious} from 'shared/web';

import {useNavigationDataApi} from '../api/useNavigationDataApi';
import {getFormattedSourceSearchParams} from '../utils/url/getFormattedSourceSearchParams';

export function useCountByQueryId() {
  const sourceParams = getFormattedSourceSearchParams();
  const http = useNavigationDataApi(sourceParams.gridCode);
  const [count, setCount] = useState<number | null>(null);

  const prevValue = usePrevious(sourceParams);

  // eslint-disable-next-line eslint-js/no-restricted-syntax -- intentional: reactive data fetch; fires when URL-derived gridCode or queryId changes between navigations; getFormattedSourceSearchParams() reads window.location at render time so deps are primitives
  useEffect(
    function fetchCountOnQueryChange() {
      if (JSON.stringify(sourceParams) === JSON.stringify(prevValue)) {
        return;
      }

      if (isNil(sourceParams.gridCode) || isNil(sourceParams.queryId)) {
        return;
      }

      http.getCountByQuery(sourceParams.queryId).then((rowCountResponse) => {
        isNumber(rowCountResponse) && setCount(rowCountResponse);
      });
    },
    [sourceParams.gridCode, sourceParams.queryId] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  return {
    count,
    hasSourceParams: Boolean(sourceParams.gridCode && sourceParams.queryId),
  };
}
